import * as ProSolidSvgIcons from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip } from 'react-tooltip'
import * as Api from 'src/api'
import { useTranslatable } from 'src/hooks/locale/utils'
import { useTheme } from 'src/state/providers/Theme'

export default function UserEmulationButton({
  user,
  emulateUser,
}: {
  user: Api.AdministratorUser
  emulateUser: (params: { userId: string }) => void
}): JSX.Element | null {
  const t = useTranslatable()
  const theme = useTheme()

  // Computed by the server with the same rule POST /auth/emulate/{userId} enforces.
  if (user.manage?.canEmulate === true) {
    return (
      <>
        <Tooltip
          id={`${user.id}-statusTooltip`}
          place="top"
          variant={theme === 'dark' ? 'dark' : 'light'}
          className="mb-1 p-1"
        >
          {t('admin_users:authorize_with_other_user')}
        </Tooltip>
        <button
          data-tooltip-id={`${user.id}-statusTooltip`}
          type="button"
          onClick={() => emulateUser({ userId: user.id })}
          className="rounded-full pl-2"
        >
          <FontAwesomeIcon icon={ProSolidSvgIcons.faUser} className="cursor-pointer" />
        </button>
      </>
    )
  }

  return null
}
